import React from 'react';
import { v4 as uuidV4 } from 'uuid';


export const DetailsName = ({ name }: { name?: string; }) => <span className="details__name">{name ?? uuidV4()}</span>;
